/* global angular, _, $ */
angular.module('ua5App.community')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('home.community', {
            url: 'community/',
            templateUrl: 'states/community/community.html',
            controller: 'CommunityCtrl',
            controllerAs: 'ctrl',
            reloadOnSearch: false,
            resolve: {
                programs: ['PostFactory', '$stateParams', function(PostFactory, $stateParams) {
                    return PostFactory.programs().query().$promise;
                }]
            }
        });
    }])
    .controller('CommunityCtrl', ['$rootScope', '$scope', '$timeout', '$state', 'SocialPostsFactory', 'LockScrollFactory', '$sce', 'MetaFactory', 'programs', function($rootScope, $scope, $timeout, $state, SocialPostsFactory, LockScrollFactory, $sce, MetaFactory, programs) {

        var vidResized = false;

        $scope.$parent.updateURL({});

        SocialPostsFactory.query().$promise.then(function(socialPosts) {

            $scope.originalContent = _.sortBy(socialPosts, 'created_at').reverse();
            $scope.currentVideo = null;
            // var items = [];
            _.each($scope.originalContent, function(content) {
                var img;
                if (content.type !== 'text') {
                    img = new Image();
                    img.onload = function() {
                        var height = img.height;
                        var width = img.width;
                        if (height < 300 || width < 300) {
                            content.type = 'text';
                        }
                    };
                    img.src = content.preview_url; //jshint ignore:line
                }
                // items.push(content.posted_by);
            });

            // function onlyUnique(value, index, self) {
            //     return self.indexOf(value) === index;
            // }
            // console.log(items.filter(onlyUnique));
            $scope.content = _.clone($scope.originalContent);
        });

        $scope.currentFilters = [];

        $scope.programFilters = [
            {
                name: 'All Programs',
                value: ''
            }
        ];

        $scope.$watch('currentFilters', function() {
            var filters;
            var typeFilters = [];
            if (typeof $scope.currentFilters === 'string') {
                filters = $scope.currentFilters.split(',');
            }
            _.each(filters, function(item) {
                switch (item) {
                    case 'general':
                        typeFilters.push('UCLAarts');
                        break;
                    case 'architecture-and-urban-design':
                        typeFilters.push('UCLA Architecture & Urban Design');
                        typeFilters.push('cityLAB');
                        typeFilters.push('cityLABucla');
                        typeFilters.push('UCLA_AUD');
                        break;
                    case 'art':
                        typeFilters.push('UCLA Summer Art Institute');
                        break;
                    case 'design-media-arts':
                        typeFilters.push('UCLA Design Media Arts');
                        typeFilters.push('ohDMA');
                        typeFilters.push('UCLA Game Lab');
                        typeFilters.push('uclagames');
                        break;
                    case 'world-arts-and-cultures-dance':
                        typeFilters.push('SPARC ART');
                        typeFilters.push('Through Positive Eyes');
                        typeFilters.push('UCLA Art & Global Health Center');
                        typeFilters.push('UCLA Sex Squad');
                        break;
                    case 'visual-and-performing-arts-education':
                        typeFilters.push('UCLA Visual and Performing Arts Education Program');
                        break;
                    case 'center-for-the-art-of-performance':
                        typeFilters.push('CAP UCLA');
                        typeFilters.push('CAP_UCLA');
                        break;
                    case 'fowler-museum':
                        typeFilters.push('Fowler Museum at UCLA');
                        typeFilters.push('FowlerMuseum');
                        break;
                    case 'hammer-museum':
                        typeFilters.push('Hammer Museum');
                        typeFilters.push('hammer_museum');
                        break;
                    case 'citylab':
                        typeFilters.push('cityLAB');
                        typeFilters.push('cityLABucla');
                        break;
                    case 'ucla-sparc':
                        typeFilters.push('SPARC ART');
                        break;
                    case 'through-positive-eyes':
                        typeFilters.push('Through Positive Eyes');
                        break;
                    case 'sex-squad':
                        typeFilters.push('UCLA Sex Squad');
                        break;
                    case 'art-global-health-center':
                        typeFilters.push('Through Positive Eyes');
                        typeFilters.push('UCLA Art & Global Health Center');
                        typeFilters.push('UCLA Sex Squad');
                        break;
                    case 'ucla-game-lab':
                        typeFilters.push('UCLA Game Lab');
                        typeFilters.push('uclagames');
                        break;
                    case 'summer-art-institute':
                        typeFilters.push('UCLA Summer Art Institute');
                }
            });

            if (typeFilters.length > 0) {
                $scope.content = _.filter($scope.originalContent, function(i) {
                    return this.keys.indexOf(i.posted_by) > -1; //jshint ignore:line
                }, {
                    keys: typeFilters
                });
            } else {
                $scope.content = _.clone($scope.originalContent);
            }
        });

        // $scope.content = _.where($scope.originalContent, {posted_by: 'UCLA_AUD'});
        // $scope.$apply();
        // function filter(data, field, values) {
        //     _.filter(data, function(item){ return _.contains(values, item[field]); })
        // }
        //)_.where($scope.originalContent, {posted_by: 'UCLA_AUD'});

        for (var i = 0; i < programs.length; i++) {
            programs[i].value = programs[i].slug;
        }
        $scope.programFilters = $scope.programFilters.concat(programs);
        $scope.programFilters.push({
            name: 'Art & Global Health Center',
            value: 'art-global-health-center'
        });
        $scope.programFilters.push({
            name: 'cityLAB',
            value: 'citylab'
        });
        $scope.programFilters.push({
            name: 'Summer Art Institute',
            value: 'summer-art-institute'
        });
        $scope.programFilters.push({
            name: 'Through Positive Eyes',
            value: 'through-positive-eyes'
        });
        $scope.programFilters.push({
            name: 'UCLA Game Lab',
            value: 'ucla-game-lab'
        });
        $scope.programFilters.push({
            name: 'UCLA Sex Squad',
            value: 'sex-squad'
        });
        $scope.programFilters.push({
            name: 'UCLA@SPARC',
            value: 'ucla-sparc'
        });

        MetaFactory.set({
            title: 'Community',
            description: 'UCLA Arts Community Social Media Feed'
        });

        $scope.openVideo = function(url) {
            // assumes youtube video
            $scope.currentVideo = $sce.trustAsResourceUrl(url.replace('.com/watch?v=', '.com/embed/') + '?autoplay=true');
            $('#community__modal--video__wrap').append('<iframe id="community__modal__iframe" src="' + $scope.currentVideo + '"></iframe>');
            resizeVideo();
            LockScrollFactory.disableScroll();
        };

        $scope.closeVideo = function() {
            $('#community__modal__iframe').remove();
            $scope.currentVideo = null;
            LockScrollFactory.enableScroll();
        };

        function broadcastState() {
            $rootScope.$broadcast('childStateLoaded', $state.current);
        }

        function resizeVideo() {
            // proportion of window is 5:3
            var vid = $('#community__modal--video__wrap'),
                heightWidthRatio = 0.6,
                winH = $(window).height() - 20,
                winW = $(window).width(),
                ratio = winH / winW;

            // window is too wide so that vid is too big, not showing top/bottom
            if (ratio < heightWidthRatio) {
                vid.css({
                    maxWidth: (winH / heightWidthRatio) + 'px',
                    paddingBottom: winH + 'px'
                });
                vidResized = true;
            } else if (vidResized) {
                // reset scaling if window is
                vid.css({
                    maxWidth: 'auto',
                    paddingBottom: ''
                });
                vidResized = false;
            }
        }

        $scope.$on('app:resized', resizeVideo);

        $scope.$on('stateRequested', broadcastState);

    }])
;
